// extracted by mini-css-extract-plugin
module.exports = {"item":"CheckboxInput_item__2Cwkk","checkbox":"CheckboxInput_checkbox__2Xslz"};